import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
const GetOrder = graphql(`
  query GetOrder($orderId: ID!) {
    order {
      get(id: $orderId) {
        id
        reference
        cart {
          sku
          name
          imageUrl
          quantity
          price {
            net
            gross
            discounts {
              percent
            }
          }
          subTotal {
            net
            gross
            discounts {
              percent
            }
          }
          meta {
            key
            value
          }
        }
        total {
          currency
          gross
          net
          discounts {
            percent
          }
        }
        payment {
          ... on CustomPayment {
            __typename
            provider
            properties {
              property
              value
            }
          }
        }
        pipelines {
          pipeline {
            id
            name
            stages {
              id
              name
            }
          }
          stageId
        }
        createdAt
        ...Customer
        meta {
          key
          value
        }
      }
    }
  }
  fragment Customer on Order {
    customer {
      identifier
      firstName
      lastName
      birthDate
      phone
      email
      addresses {
        type
        firstName
        lastName
        street
        postalCode
        city
        country
        email
        phone
      }
      externalReferences {
        key
        value
      }
      meta {
        key
        value
      }
    }
  }
`);
export default GetOrder;
